// @ts-nocheck
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './supabase.js';

// Helper to get env vars lazily at call time
function getEnvVars() {
  // @ts-ignore
  const url = (typeof import.meta !== 'undefined' && (import.meta.env?.VITE_SUPABASE_URL || import.meta.env?.PUBLIC_SUPABASE_URL || import.meta.env?.SUPABASE_URL))
    || (typeof process !== 'undefined' && (process.env?.VITE_SUPABASE_URL || process.env?.PUBLIC_SUPABASE_URL || process.env?.SUPABASE_URL))
    || '';
  // @ts-ignore
  const key = (typeof import.meta !== 'undefined' && (import.meta.env?.VITE_SUPABASE_ANON_KEY || import.meta.env?.PUBLIC_SUPABASE_ANON_KEY || import.meta.env?.SUPABASE_ANON_KEY))
    || (typeof process !== 'undefined' && (process.env?.VITE_SUPABASE_ANON_KEY || process.env?.PUBLIC_SUPABASE_ANON_KEY || process.env?.SUPABASE_ANON_KEY))
    || '';

  if (!url || !key) {
    throw new Error('Supabase URL and Anon Key must be provided');
  }
  return { url, key };
}

// Singleton client for browser
let clientInstance: SupabaseClient<Database> | null = null;

export function getSupabaseClient(): SupabaseClient<Database> {
  if (clientInstance) return clientInstance;

  const { url, key } = getEnvVars();

  if (!url || !key) {
    throw new Error('Supabase URL and Anon Key are required');
  }

  clientInstance = createClient<Database>(url, key, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });

  return clientInstance;
}

// Server-side client (with service role if needed)
export function getServiceSupabaseClient(): SupabaseClient<Database> {
  const { url } = getEnvVars();
  const serviceRoleKey = process.env.SUPABASE_SERVICE_ROLE_KEY;
  
  if (!serviceRoleKey) {
    throw new Error('Service role key not available');
  }
  
  return createClient<Database>(url, serviceRoleKey, {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
    },
  });
}

// Create a fresh client instance (for SSR/Astro)
export function createFreshClient(
  accessToken?: string
): SupabaseClient<Database> {
  const { url, key } = getEnvVars();
  const client = createClient<Database>(url, key, {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
    },
    global: accessToken ? {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    } : undefined,
  });
  
  return client;
}

export type { Database } from './supabase.js';
export type TypedSupabaseClient = SupabaseClient<Database>;
